<rid-categorise
  class="h-dvh"
  name="Sorteren (gemengd)"
  [questions]="[
    {
      id: '0',
      assignment: 'Sleep het woord op de juiste afbeelding',
      item: { type: 'WORD', word: 'tijger' },
      options: [
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/BJuCpMZwjLRDH22qN_3C-.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/tRbHTlab4z8VFbpW_d-7z.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
        },
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/EnNEt6JxcpmKOEZK0mbG9.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
        },
      ],
      answer: 1,
    },
    {
      id: '1',
      assignment: 'Sleep het woord op het juiste geluid',
      item: { type: 'WORD', word: 'tijger' },
      options: [
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
        },
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
        },
      ],
      answer: 1,
    },
    {
      id: '2',
      assignment: 'Sleep het geluid op het juiste woord',
      item: {
        type: 'AUDIO',
        src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
      },
      options: [
        { type: 'CONTENT', text: 'leeuw' },
        { type: 'CONTENT', text: 'tijger' },
        { type: 'CONTENT', text: 'zebra' },
      ],
      answer: 2,
    },
    {
      id: '3',
      assignment: 'Sleep het woord op het juiste regelsymbool',
      item: { type: 'WORD', word: 'dubbelzetter' },
      options: [
        { type: 'RULE', rule: '+' },
        { type: 'RULE', rule: '-' },
        { type: 'RULE', rule: '→' },
      ],
      answer: 0,
    },
    {
      id: '1.1',
      assignment: 'Sleep het woord op het juiste geluid',
      item: { type: 'WORD', word: 'tijger' },
      options: [
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
        },
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
        },
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
      ],
      answer: 0,
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/categorise'])"
/>
